module.exports = __webpack_public_path__ + "static/banner-e553eb79736e464537735e643d147d77.png";